import React from 'react';

import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import Item from './item';

import {InitialItemsProps} from './types';

import './initial-items.css';

const i18n = I18N.surveyCreate.presetDescription;
const b = b_.with('preset-description');

export default function InitialItems(props: InitialItemsProps) {
    const {items} = props;

    return (
        <div className={b('content', {type: 'initial'})}>
            <div className={b('items', {type: 'initial'})}>
                <div className={b('items-header')}>
                    <h3 className={b('items-title')}>{i18n.pickedQuestions}</h3>
                </div>
                {items.map(item => (
                    <Item key={item.id} label={item.config.label} theme='initial' />
                ))}
            </div>
        </div>
    );
}
